module.exports = "/static/assets/96ae033a1d0502aa4a8471884748f619.gif";